export class AppConstants {
  static readonly NUM_PAGES = 100; //Es el numero máximo de paginas por lote
  static readonly ROWS_PER_PAGE = 15; //Es la cantidad de registros por página
  static readonly MAX_ROWS_PER_BATCH = 1501; //Es el tamaño máximo del lote
  static readonly FIRST_PAGE = 1; //Indica el numero de la primer página
  static readonly DIFF_PAGE = 2; //Es la diferencia de paginas (arriba/abajo) que se visualizan en el paginador
  static readonly MAX_PAGE_VIEW = 5; //Es la cantidad máxima de paginas del paginador
  static readonly MAX_ROWS_PER_REPORT_VALIDATE = 10000000 //Es la cantidad máxima de registros por reporte, 10 Millones
  static readonly MAX_ROWS_PER_EXCEL = 700000 //Es la cantidad máxima de registros por reporte, 10 Millones
}
